import './wizard.scss';
import {WizardController} from './wizardController';

export function wizard(): ng.IDirective {
    return {
        restrict: 'EA',
        replace: true,
        transclude: true,
        scope: true,
        bindToController: {
            wizardSteps: '=',
            currentStep: '=',
            isValid: '&',
            isLastStepConfirmationPage: '=',
            onClickCheck: '=',
            onClickMessage: '=',
        },
        template: require('./wizard.html'),
        controller: WizardController,
        controllerAs: 'wizardVm'
    }
}

angular
    .module('deliveryCreate.app')
    .directive('wizard', wizard);


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/core/wizard/wizardDirective.ts
 **/